import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import FeaturedVideos from './components/FeaturedVideos';
import CategoryNav from './components/CategoryNav';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import GuideSection from './components/GuideSection';
import CTASection from './components/CTASection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '蘑菇视频网页版',
  url: 'https://www.moguvideo.com/',
  description: '蘑菇视频网页版是无需下载App即可直接在浏览器观看的视频平台入口。提供电视剧、电影、综艺、动漫、纪录片等海量视频内容。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.moguvideo.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <SchemaOrg schema={homeSchema} />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedVideos />
        <CategoryNav />
        <GuideSection />
        <LatestArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}